import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Config } from "../../../core/config";
import {
  MakePaymentRequest,
  MakePaymentResponse,
  CreatePaymentRequest,
  PaymentPageReq,
} from "../model/makePaymentReq";
import { CreateMandate } from "../model/mandate";
import { DataStore } from "../../../shared/data-store.service";
import { environment } from "../../../../environments/environment";

@Injectable()
export class PaymentService {
  constructor(
    private http: HttpClient,
    private resource: Config,
    private dataservice: DataStore
  ) {}
  baseUrl: string = environment.ghBaseUrl;
  // baseUrl = this.resource.url;

  //make payment (deprecated  -- replaced by  payment page)
  makePayment(payrequest: MakePaymentRequest) {
    return this.http.post<MakePaymentResponse>(
      `${this.baseUrl}${this.resource.paymentReq}`,
      JSON.stringify(payrequest)
    );
  }

  //createMandate
  createMandate(payrequest: CreateMandate) {
    return this.http.post(
      `${this.baseUrl}${this.resource.createMandate}`,
      JSON.stringify(payrequest)
    );
  }

  paymentPage(payreq: PaymentPageReq) {
    return this.http.post<MakePaymentResponse>(
      `${this.baseUrl}${this.resource.paymentPage}`,
      JSON.stringify(payreq)
    );
  }

  // message = {
  //   reference: Date.now().toString(),
  //   userId: "ga",
  //   amount: 1000,
  //   currency: "NGN",
  //   callbackUrl: "http://pgs.com"
  // };

  createPayment(createPaymentRequest: CreatePaymentRequest) {
    return this.http.post(
      `${this.baseUrl}${this.resource.createPayment}`,
      JSON.stringify(createPaymentRequest)
    );
  }

  getPaymentPages(id) {
    let queryParams = new HttpParams();
    queryParams = queryParams.set("startDate", "2020-01-01");
    return this.http.get(
      `${this.baseUrl}${this.resource.paymentPages}${id}/paymentPages`,
      { params: queryParams }
    );
  }
}
